module.exports = __webpack_public_path__ + "static/img/card_3_1.33f7c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_3_1.png
// module id = JhvU
// module chunks = 0